// extracted by mini-css-extract-plugin
export default {"GridView":"styles_GridView__atKDN"};